import React, { useState } from 'react';
import { Button, Dialog, Input } from '@alifd/next';
import styles from './index.module.scss';

function InsertCoupon(props) {
  const {couponVisible, setCouponVisible,couponConfirm} = props;
  const [couponId, setCouponId] = useState('');
  const [couponTipsVisible,setCouponTipsVisible] = useState(false);
  return (
    <Dialog
      visible={couponVisible}
      onClose={()=>{setCouponVisible(false)}}
      onOk={()=>{couponConfirm(couponId)}}
      title='插入优惠券'
      width={500}
      v2
    >
      <div className={styles['big-box']}>
        <div className={styles['title-box']}>
          <div>优惠券ID:</div>
          <Input
            value={couponId}
            onChange={(v)=>{setCouponId(v)}}
            style={{width:'300px',marginLeft:'10px'}}
          />
        </div>
        <div className={styles['tips-box']}>
          <Button text type='primary' onClick={()=>{setCouponTipsVisible(true)}}>获取优惠券ID帮助教程</Button>
        </div>
      </div>
      {
        couponTipsVisible && <Dialog v2 width={675} footer={false} visible={couponTipsVisible} onClose={()=>{setCouponTipsVisible(false)}}>
          <div>
            <div className={`${styles['btn-box']} ${styles['tips-text']}`}>
              一、在店铺后台选择优惠券（没有优惠券可以新建优惠券）：
              <Button text type='primary' style={{fontSize:'15px'}} onClick={()=>{window.open('https://fxg.jinritemai.com/ffa/marketing/coupon/home?tab=manage')}}>点击即可前往优惠券管理页</Button>
            </div>
            <div className={styles['tips-text']}>
              二、找到你要发送的优惠券，点击复制按钮进行复制:
              <img src='//img10.360buyimg.com/imgzone/jfs/t1/105866/28/54918/36734/67288044F7122b71f/05e41fae2b774be8.png' alt='优惠券操作指南' style={{marginTop:'10px'}}/>
            </div>
          </div>        
        </Dialog>
      }
    </Dialog>
  );
}

export default InsertCoupon;
